import { MapPin, Phone, Mail, User } from "lucide-react";
import { LOGO_URL } from "@/config/assets";
import {
  VENUE_ADDRESS,
  CONTACT_PERSON,
  CONTACT_MOBILE,
  CONTACT_MOBILE_DISPLAY,
  BOOKING_EMAIL,
} from "@/config/siteConfig";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Venues & Amenities", href: "#venues" },
  { label: "Gallery", href: "#gallery" },
  { label: "Book Now", href: "#contact" },
];

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#043927] border-t border-[#D4AF37]/25">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div data-testid="footer-brand-column">
        <div className="flex items-center gap-4">
          <img src={LOGO_URL} alt="Leelarav Greens logo" className="h-12 w-12 rounded-sm object-cover border border-[#D4AF37]/40" />
          <div>
            <p className="font-serif-luxe text-2xl text-[#F3E5AB]">Leelarav Greens</p>
            <p className="text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">Luxury Venue</p>
          </div>
        </div>
        <p className="mt-6 text-sm font-light leading-relaxed text-[#FAF9F6]/60">
          Where Nature Meets Grandeur. Gujarat's premier luxury venue for weddings, corporate galas, and elite celebrations since 2022.
        </p>
      </div>

      <div data-testid="footer-address-column">
        <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Address</h4>
        <p className="flex items-start gap-3 text-sm font-light leading-relaxed text-[#F3E5AB]/85">
          <MapPin size={17} className="text-[#D4AF37] shrink-0 mt-0.5" strokeWidth={1.5} />
          <span data-testid="footer-address-text">{VENUE_ADDRESS}</span>
        </p>
      </div>

      <div data-testid="footer-contact-column">
        <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Contact</h4>
        <ul className="space-y-4 text-sm font-light text-[#FAF9F6]/75">
          <li className="flex items-center gap-3">
            <User size={16} className="text-[#D4AF37] shrink-0" strokeWidth={1.5} />
            {CONTACT_PERSON}
          </li>
          <li>
            <a href={`tel:${CONTACT_MOBILE}`} data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors duration-300">
              <Phone size={16} className="text-[#D4AF37] shrink-0" strokeWidth={1.5} />
              {CONTACT_MOBILE_DISPLAY}
            </a>
          </li>
          <li>
            <a href={`mailto:${BOOKING_EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors duration-300">
              <Mail size={16} className="text-[#D4AF37] shrink-0" strokeWidth={1.5} />
              {BOOKING_EMAIL}
            </a>
          </li>
        </ul>
      </div>

      <div data-testid="footer-links-column">
        <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Explore</h4>
        <ul className="space-y-3 text-sm font-light text-[#FAF9F6]/75">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a href={l.href} className="hover:text-[#D4AF37] transition-colors duration-300">{l.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-[#D4AF37]/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs font-light text-[#FAF9F6]/45">© {new Date().getFullYear()} Leelarav Greens. All rights reserved.</p>
        <p className="text-xs font-light tracking-[0.25em] uppercase text-[#D4AF37]/70">Where Nature Meets Grandeur</p>
      </div>
    </div>
  </footer>
);
